import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

import { EuiSlideToggleComponent } from './eui-slide-toggle.component';

@NgModule({
    imports: [
        CommonModule,
        MatSlideToggleModule,
    ],
    declarations: [
        EuiSlideToggleComponent,
    ],
    exports: [
        EuiSlideToggleComponent,
    ],
})
export class EuiSlideToggleModule { }
